module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Files/Folder-star-7700bd73af9edf727de7142e79571fac.svg";